import { ResultsCountMessage } from '../components/results/results-count-msg';
import { ResultsProps } from '../state-helpers/site-settings-props';

export function getResultsText(totalResults: number,
    pageResults: number,
    pageSize: number,
    currentPage: number,
    isLoading: boolean,
    resultsProps: ResultsProps)
{
    let resultsText: string;

    if (isLoading) {
        resultsText = resultsProps.loadingResultsText;
    } else if (totalResults == 0 || (totalResults <= pageSize * (currentPage - 1))) {
        // Show Zero Results message if no results or out of range
        resultsText = resultsProps.zeroResultsText;
    } else {
        let rangeFirst = ((currentPage - 1) * pageSize) + 1;
        let rangeLast = totalResults < pageSize ? totalResults : rangeFirst + pageResults - 1;
        let rangeStr = (rangeFirst == rangeLast) ? rangeFirst.toString() : `${rangeFirst.toString()} - ${rangeLast.toString()}`;
        resultsText = resultsProps.amountOfResultsText.replace("##TOTAL##", totalResults.toString()).replace("##PAGE##", rangeStr);
    }
    return resultsText;
}